<div *ngIf="isLoading" class="loaderMask">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>
